/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BuchungserstellAntragDto } from '../models/buchungserstell-antrag-dto';
import { cancelOneGleittagErstellAntrag$Json } from '../fn/buchungserstell-antrags/cancel-one-gleittag-erstell-antrag-json';
import { CancelOneGleittagErstellAntrag$Json$Params } from '../fn/buchungserstell-antrags/cancel-one-gleittag-erstell-antrag-json';
import { cancelOneGleittagErstellAntrag$Plain } from '../fn/buchungserstell-antrags/cancel-one-gleittag-erstell-antrag-plain';
import { CancelOneGleittagErstellAntrag$Plain$Params } from '../fn/buchungserstell-antrags/cancel-one-gleittag-erstell-antrag-plain';
import { createBuchungserstellAntrag$Json } from '../fn/buchungserstell-antrags/create-buchungserstell-antrag-json';
import { CreateBuchungserstellAntrag$Json$Params } from '../fn/buchungserstell-antrags/create-buchungserstell-antrag-json';
import { createBuchungserstellAntrag$Plain } from '../fn/buchungserstell-antrags/create-buchungserstell-antrag-plain';
import { CreateBuchungserstellAntrag$Plain$Params } from '../fn/buchungserstell-antrags/create-buchungserstell-antrag-plain';
import { getAllErstellAntraegePaginated$Json } from '../fn/buchungserstell-antrags/get-all-erstell-antraege-paginated-json';
import { GetAllErstellAntraegePaginated$Json$Params } from '../fn/buchungserstell-antrags/get-all-erstell-antraege-paginated-json';
import { getAllErstellAntraegePaginated$Plain } from '../fn/buchungserstell-antrags/get-all-erstell-antraege-paginated-plain';
import { GetAllErstellAntraegePaginated$Plain$Params } from '../fn/buchungserstell-antrags/get-all-erstell-antraege-paginated-plain';
import { getGleittagAntraegeForMitarbeiter$Json } from '../fn/buchungserstell-antrags/get-gleittag-antraege-for-mitarbeiter-json';
import { GetGleittagAntraegeForMitarbeiter$Json$Params } from '../fn/buchungserstell-antrags/get-gleittag-antraege-for-mitarbeiter-json';
import { getGleittagAntraegeForMitarbeiter$Plain } from '../fn/buchungserstell-antrags/get-gleittag-antraege-for-mitarbeiter-plain';
import { GetGleittagAntraegeForMitarbeiter$Plain$Params } from '../fn/buchungserstell-antrags/get-gleittag-antraege-for-mitarbeiter-plain';
import { getOffeneBuchungserstellAntraege$Json } from '../fn/buchungserstell-antrags/get-offene-buchungserstell-antraege-json';
import { GetOffeneBuchungserstellAntraege$Json$Params } from '../fn/buchungserstell-antrags/get-offene-buchungserstell-antraege-json';
import { getOffeneBuchungserstellAntraege$Plain } from '../fn/buchungserstell-antrags/get-offene-buchungserstell-antraege-plain';
import { GetOffeneBuchungserstellAntraege$Plain$Params } from '../fn/buchungserstell-antrags/get-offene-buchungserstell-antraege-plain';
import { getOffeneBuchungserstellAntraegeCount$Json } from '../fn/buchungserstell-antrags/get-offene-buchungserstell-antraege-count-json';
import { GetOffeneBuchungserstellAntraegeCount$Json$Params } from '../fn/buchungserstell-antrags/get-offene-buchungserstell-antraege-count-json';
import { getOffeneBuchungserstellAntraegeCount$Plain } from '../fn/buchungserstell-antrags/get-offene-buchungserstell-antraege-count-plain';
import { GetOffeneBuchungserstellAntraegeCount$Plain$Params } from '../fn/buchungserstell-antrags/get-offene-buchungserstell-antraege-count-plain';
import { updateOneBuchungserstellAntrag$Json } from '../fn/buchungserstell-antrags/update-one-buchungserstell-antrag-json';
import { UpdateOneBuchungserstellAntrag$Json$Params } from '../fn/buchungserstell-antrags/update-one-buchungserstell-antrag-json';
import { updateOneBuchungserstellAntrag$Plain } from '../fn/buchungserstell-antrags/update-one-buchungserstell-antrag-plain';
import { UpdateOneBuchungserstellAntrag$Plain$Params } from '../fn/buchungserstell-antrags/update-one-buchungserstell-antrag-plain';

@Injectable({ providedIn: 'root' })
export class BuchungserstellAntragsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllErstellAntraegePaginated()` */
  static readonly GetAllErstellAntraegePaginatedPath = '/v1/buchungserstellAntraege';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllErstellAntraegePaginated$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllErstellAntraegePaginated$Plain$Response(params?: GetAllErstellAntraegePaginated$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungserstellAntragDto>>> {
    return getAllErstellAntraegePaginated$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllErstellAntraegePaginated$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllErstellAntraegePaginated$Plain(params?: GetAllErstellAntraegePaginated$Plain$Params, context?: HttpContext): Observable<Array<BuchungserstellAntragDto>> {
    return this.getAllErstellAntraegePaginated$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BuchungserstellAntragDto>>): Array<BuchungserstellAntragDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllErstellAntraegePaginated$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllErstellAntraegePaginated$Json$Response(params?: GetAllErstellAntraegePaginated$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungserstellAntragDto>>> {
    return getAllErstellAntraegePaginated$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllErstellAntraegePaginated$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllErstellAntraegePaginated$Json(params?: GetAllErstellAntraegePaginated$Json$Params, context?: HttpContext): Observable<Array<BuchungserstellAntragDto>> {
    return this.getAllErstellAntraegePaginated$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BuchungserstellAntragDto>>): Array<BuchungserstellAntragDto> => r.body)
    );
  }

  /** Path part for operation `createBuchungserstellAntrag()` */
  static readonly CreateBuchungserstellAntragPath = '/v1/buchungen/{mitarbeiterId}/erstellAntrag';

  /**
   * Erstellt einen BuchungserstellAntrag für den angebenen Benutzer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createBuchungserstellAntrag$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createBuchungserstellAntrag$Plain$Response(params: CreateBuchungserstellAntrag$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungserstellAntragDto>> {
    return createBuchungserstellAntrag$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Erstellt einen BuchungserstellAntrag für den angebenen Benutzer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createBuchungserstellAntrag$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createBuchungserstellAntrag$Plain(params: CreateBuchungserstellAntrag$Plain$Params, context?: HttpContext): Observable<BuchungserstellAntragDto> {
    return this.createBuchungserstellAntrag$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<BuchungserstellAntragDto>): BuchungserstellAntragDto => r.body)
    );
  }

  /**
   * Erstellt einen BuchungserstellAntrag für den angebenen Benutzer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createBuchungserstellAntrag$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createBuchungserstellAntrag$Json$Response(params: CreateBuchungserstellAntrag$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungserstellAntragDto>> {
    return createBuchungserstellAntrag$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Erstellt einen BuchungserstellAntrag für den angebenen Benutzer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createBuchungserstellAntrag$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createBuchungserstellAntrag$Json(params: CreateBuchungserstellAntrag$Json$Params, context?: HttpContext): Observable<BuchungserstellAntragDto> {
    return this.createBuchungserstellAntrag$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<BuchungserstellAntragDto>): BuchungserstellAntragDto => r.body)
    );
  }

  /** Path part for operation `updateOneBuchungserstellAntrag()` */
  static readonly UpdateOneBuchungserstellAntragPath = '/v1/buchungserstellAntraege/{antragsId}';

  /**
   * Aktualisiert einen BuchungserstellAntrag.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBuchungserstellAntrag$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateOneBuchungserstellAntrag$Plain$Response(params: UpdateOneBuchungserstellAntrag$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungserstellAntragDto>> {
    return updateOneBuchungserstellAntrag$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Aktualisiert einen BuchungserstellAntrag.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBuchungserstellAntrag$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateOneBuchungserstellAntrag$Plain(params: UpdateOneBuchungserstellAntrag$Plain$Params, context?: HttpContext): Observable<BuchungserstellAntragDto> {
    return this.updateOneBuchungserstellAntrag$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<BuchungserstellAntragDto>): BuchungserstellAntragDto => r.body)
    );
  }

  /**
   * Aktualisiert einen BuchungserstellAntrag.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBuchungserstellAntrag$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateOneBuchungserstellAntrag$Json$Response(params: UpdateOneBuchungserstellAntrag$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungserstellAntragDto>> {
    return updateOneBuchungserstellAntrag$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Aktualisiert einen BuchungserstellAntrag.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBuchungserstellAntrag$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateOneBuchungserstellAntrag$Json(params: UpdateOneBuchungserstellAntrag$Json$Params, context?: HttpContext): Observable<BuchungserstellAntragDto> {
    return this.updateOneBuchungserstellAntrag$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<BuchungserstellAntragDto>): BuchungserstellAntragDto => r.body)
    );
  }

  /** Path part for operation `cancelOneGleittagErstellAntrag()` */
  static readonly CancelOneGleittagErstellAntragPath = '/v1/buchungserstellAntraege/{antragsId}/cancel';

  /**
   * Storniert einen angenommenen GleittagErstellAntrag oder zieht einen offenen GleittagErstellAntrag zurueck.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelOneGleittagErstellAntrag$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelOneGleittagErstellAntrag$Plain$Response(params: CancelOneGleittagErstellAntrag$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungserstellAntragDto>> {
    return cancelOneGleittagErstellAntrag$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Storniert einen angenommenen GleittagErstellAntrag oder zieht einen offenen GleittagErstellAntrag zurueck.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cancelOneGleittagErstellAntrag$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelOneGleittagErstellAntrag$Plain(params: CancelOneGleittagErstellAntrag$Plain$Params, context?: HttpContext): Observable<BuchungserstellAntragDto> {
    return this.cancelOneGleittagErstellAntrag$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<BuchungserstellAntragDto>): BuchungserstellAntragDto => r.body)
    );
  }

  /**
   * Storniert einen angenommenen GleittagErstellAntrag oder zieht einen offenen GleittagErstellAntrag zurueck.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelOneGleittagErstellAntrag$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelOneGleittagErstellAntrag$Json$Response(params: CancelOneGleittagErstellAntrag$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungserstellAntragDto>> {
    return cancelOneGleittagErstellAntrag$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Storniert einen angenommenen GleittagErstellAntrag oder zieht einen offenen GleittagErstellAntrag zurueck.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cancelOneGleittagErstellAntrag$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelOneGleittagErstellAntrag$Json(params: CancelOneGleittagErstellAntrag$Json$Params, context?: HttpContext): Observable<BuchungserstellAntragDto> {
    return this.cancelOneGleittagErstellAntrag$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<BuchungserstellAntragDto>): BuchungserstellAntragDto => r.body)
    );
  }

  /** Path part for operation `getOffeneBuchungserstellAntraegeCount()` */
  static readonly GetOffeneBuchungserstellAntraegeCountPath = '/v1/erstellAntraege/offen/count';

  /**
   * Holt die Anzahl aller offenen BuchungserstellAntraege fuer (nicht) Monteursbuchungen.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOffeneBuchungserstellAntraegeCount$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOffeneBuchungserstellAntraegeCount$Plain$Response(params?: GetOffeneBuchungserstellAntraegeCount$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return getOffeneBuchungserstellAntraegeCount$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt die Anzahl aller offenen BuchungserstellAntraege fuer (nicht) Monteursbuchungen.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOffeneBuchungserstellAntraegeCount$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOffeneBuchungserstellAntraegeCount$Plain(params?: GetOffeneBuchungserstellAntraegeCount$Plain$Params, context?: HttpContext): Observable<number> {
    return this.getOffeneBuchungserstellAntraegeCount$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * Holt die Anzahl aller offenen BuchungserstellAntraege fuer (nicht) Monteursbuchungen.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOffeneBuchungserstellAntraegeCount$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOffeneBuchungserstellAntraegeCount$Json$Response(params?: GetOffeneBuchungserstellAntraegeCount$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return getOffeneBuchungserstellAntraegeCount$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt die Anzahl aller offenen BuchungserstellAntraege fuer (nicht) Monteursbuchungen.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOffeneBuchungserstellAntraegeCount$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOffeneBuchungserstellAntraegeCount$Json(params?: GetOffeneBuchungserstellAntraegeCount$Json$Params, context?: HttpContext): Observable<number> {
    return this.getOffeneBuchungserstellAntraegeCount$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `getOffeneBuchungserstellAntraege()` */
  static readonly GetOffeneBuchungserstellAntraegePath = '/v1/mitarbeiter/{mitarbeiterId}/erstellAntraege/offen';

  /**
   * Holt alle offenen BuchungserstellAntraege für einen Mitarbeiter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOffeneBuchungserstellAntraege$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOffeneBuchungserstellAntraege$Plain$Response(params: GetOffeneBuchungserstellAntraege$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungserstellAntragDto>>> {
    return getOffeneBuchungserstellAntraege$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt alle offenen BuchungserstellAntraege für einen Mitarbeiter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOffeneBuchungserstellAntraege$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOffeneBuchungserstellAntraege$Plain(params: GetOffeneBuchungserstellAntraege$Plain$Params, context?: HttpContext): Observable<Array<BuchungserstellAntragDto>> {
    return this.getOffeneBuchungserstellAntraege$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BuchungserstellAntragDto>>): Array<BuchungserstellAntragDto> => r.body)
    );
  }

  /**
   * Holt alle offenen BuchungserstellAntraege für einen Mitarbeiter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOffeneBuchungserstellAntraege$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOffeneBuchungserstellAntraege$Json$Response(params: GetOffeneBuchungserstellAntraege$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungserstellAntragDto>>> {
    return getOffeneBuchungserstellAntraege$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt alle offenen BuchungserstellAntraege für einen Mitarbeiter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOffeneBuchungserstellAntraege$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOffeneBuchungserstellAntraege$Json(params: GetOffeneBuchungserstellAntraege$Json$Params, context?: HttpContext): Observable<Array<BuchungserstellAntragDto>> {
    return this.getOffeneBuchungserstellAntraege$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BuchungserstellAntragDto>>): Array<BuchungserstellAntragDto> => r.body)
    );
  }

  /** Path part for operation `getGleittagAntraegeForMitarbeiter()` */
  static readonly GetGleittagAntraegeForMitarbeiterPath = '/v1/mitarbeiter/{mitarbeiterId}/gleittagAntraege';

  /**
   * Holt alle Gleittag-Anträge für einen Mitarbeiter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGleittagAntraegeForMitarbeiter$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGleittagAntraegeForMitarbeiter$Plain$Response(params: GetGleittagAntraegeForMitarbeiter$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungserstellAntragDto>>> {
    return getGleittagAntraegeForMitarbeiter$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt alle Gleittag-Anträge für einen Mitarbeiter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGleittagAntraegeForMitarbeiter$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGleittagAntraegeForMitarbeiter$Plain(params: GetGleittagAntraegeForMitarbeiter$Plain$Params, context?: HttpContext): Observable<Array<BuchungserstellAntragDto>> {
    return this.getGleittagAntraegeForMitarbeiter$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BuchungserstellAntragDto>>): Array<BuchungserstellAntragDto> => r.body)
    );
  }

  /**
   * Holt alle Gleittag-Anträge für einen Mitarbeiter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGleittagAntraegeForMitarbeiter$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGleittagAntraegeForMitarbeiter$Json$Response(params: GetGleittagAntraegeForMitarbeiter$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungserstellAntragDto>>> {
    return getGleittagAntraegeForMitarbeiter$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt alle Gleittag-Anträge für einen Mitarbeiter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGleittagAntraegeForMitarbeiter$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGleittagAntraegeForMitarbeiter$Json(params: GetGleittagAntraegeForMitarbeiter$Json$Params, context?: HttpContext): Observable<Array<BuchungserstellAntragDto>> {
    return this.getGleittagAntraegeForMitarbeiter$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BuchungserstellAntragDto>>): Array<BuchungserstellAntragDto> => r.body)
    );
  }

}
